import { IQDialog } from '../../../common'
import Button from '@mui/material/Button'
import { Stack, Typography } from '@mui/material'
import { EntitiesTypes, getEntityTitle } from '../../../../view/admin/ad-management/EntitiesTabs'

interface IProps {
  isShow: boolean
  isCreate: boolean
  type: EntitiesTypes
  onClose: () => void
  onCancel: () => void
}

export const EntityGroupsCancel = ({ isShow, type, isCreate, onClose, onCancel }: IProps) => {
  const titleName = getEntityTitle(type)
  return (
    <IQDialog
      isShow={isShow}
      title={
        <Typography
          fontWeight={700}
          variant='h6'
        >
          {`Are you sure you want to cancel ${titleName} ${isCreate ? 'creation' : 'update'}?`}
        </Typography>
      }
      content={
        <>
          <span style={{ fontWeight: 'bold' }}>Please Note!</span> All unsaved changes will be lost.
        </>
      }
      actions={
        <Stack
          direction='row'
          spacing={2}
          justifyContent='space-between'
          sx={{
            width: '100%',
          }}
        >
          <Button
            onClick={onClose}
            variant='outlined'
            data-testid={`${type}-cancel-cancel`}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            onClick={onCancel}
            data-testid={`${type}-cancel-ok`}
          >
            Confirm
          </Button>
        </Stack>
      }
      onClose={onClose}
      testPrefix={`${type}-cancel`}
    />
  )
}
